// extracted by mini-css-extract-plugin
export default {"productGallery":"IG-z","inQuickShop":"JG-z"};